import * as z from "zod";

const schema = z.object({
	id: z.string().default("")
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantModifyResModel = {schema, model};
export type ITaxAccountantModifyResModel = z.infer<typeof TaxAccountantModifyResModel.model>;
export const DEFAULT_TAX_ACCOUNTANT_MODIFY_RES: ITaxAccountantModifyResModel = {
	id: ""
};
